import { Link } from 'gatsby';
import { DocsHeading } from "../../../../src/components/DocsHeading";
import "../../../../src/pages/design/design-guidelines-styles.css";
import { LeadParagraph } from "../../../../src/components/LeadParagraph";
import { Button } from 'react-magma-dom';
import * as React from 'react';
export default {
  Link,
  DocsHeading,
  LeadParagraph,
  Button,
  React
};